import { defineField, defineType } from 'sanity'
import getPageInfo, { seoGroup } from '../../objects/pageInfo'
import { strongEmLink } from '../../../data/richText'

export default defineType({
  title: 'Contact',
  name: 'contact',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      group: 'content',
    }),
    defineField({
      title: 'Contact Form Title',
      name: 'formTitle',
      type: 'string',
      group: 'content',
    }),
    defineField({
      title: 'Contact Form Description',
      name: 'formInfo',
      type: 'array',
      of: strongEmLink,
      group: 'content',
    }),
    defineField({
      name: 'embedCode',
      title: 'Embed code',
      type: 'text',
      description: 'iFrame embed code',
      validation: (rule) => rule.required(),
      group: 'content',
    }),
    getPageInfo({ lockCanonical: true }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})